export var COUNTRY_COOKIE_KEY = '__creh_country_code';
export var LANGUAGE_COOKIE_KEY = '__creh_language_code';
export var SESSION_DISTINCT_ID_COOKIE_KEY = 'session_distinct_id';